// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b640e1d","453":"5ea65c8c","455":"a574d64e"}[chunkId] + ".chunk.js";
};